/** ----------------------------------------
    Imports
 ---------------------------------------- */

import { ProjectStore } from '@interface/store/Project';
import { StoreHelper } from '@fruitpackage/helpers';
import resetState from './state';
import moment from 'moment';

/** ----------------------------------------
    Mutations
 ---------------------------------------- */

let baseMutations = { 
    setCurrent(state: ProjectStore, data: object) {
        // Set organisation in formation
        data.organization_in_formation = null;
        
        // Set starting date valid
        const startDate = moment(data.starts_at);
        const nowDate = moment();
        data.starting_date_valid = (startDate.diff(nowDate, 'weeks') >= 8);
        
        state.current = data;
    },

    clearState(state: ProjectStore) {
        state = resetState();
    }
};

const mutations = { 
    ...baseMutations, 
    ...StoreHelper.resetStateMutation(resetState)
}

/** ----------------------------------------
    Export Actions
 ---------------------------------------- */

export default mutations;